module.exports = __webpack_public_path__ + "static/media/sf_1500_gray.8940e88686d4d911199d756ef5c7fbcd.png";